const readOnlyTheme = {
  [`
  & input[readonly],
  & *:disabled,
  & .form-control:disabled,
  & .flex-dropdown-root.disabled .flex-dropdown-wrapper .selection
`]: {
    // Display Radio and Checkbox icons
    '& + span[class*="radioIcon"], span[class*="checkboxIcon"]': {
      display: 'block',
      '& svg': {
        display: 'block'
      }
    },
    // Handle calendar icon
    '& + span': {
      display: 'none'
    },
    '& .caret': {
      display: 'none'
    },
    '& svg': {
      display: 'none'
    },
    '& ~ svg': {
      display: 'none'
    },
    background: 'none',
    border: 'none',
    boxShadow: 'none',
    padding: 0,
    textAlign: 'left'
  }
};

export default readOnlyTheme;
